module.exports = __webpack_public_path__ + "static/media/atendimento-fraterno.c046f4d8.md";